import React from 'react';
export default function KitNumberCell({ tdProps, dataItem }) {
    if (!dataItem.pdfUrl) {
        return React.createElement("td", Object.assign({}, tdProps), dataItem.kitNumber);
    }
    return (React.createElement("td", Object.assign({}, tdProps),
        React.createElement("a", { href: dataItem.pdfUrl, target: "_blank", rel: "noopener noreferrer" }, dataItem.kitNumber)));
}
